import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/xiugaijiantou.png'


const _withScopeId = n => (_pushScopeId("data-v-f30a9230"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "changelogin" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-f30a9230><div class=\"left\" data-v-f30a9230><i class=\"iconfont icon-shenfenleibie one\" data-v-f30a9230></i><div class=\"verify\" data-v-f30a9230>身份验证</div></div><img src=\"" + _imports_0 + "\" class=\"icon\" alt=\"\" data-v-f30a9230><div class=\"right\" data-v-f30a9230><i class=\"iconfont icon-xiugaimima1 two\" data-v-f30a9230></i><div class=\"changepwd\" data-v-f30a9230>修改密码</div></div></div>", 1)
const _hoisted_3 = { class: "number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "binding" }, "关联手机号", -1))
const _hoisted_5 = { class: "getcode" }
const _hoisted_6 = {
  key: 1,
  class: "phone-code-button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("span", null, _toDisplayString(_ctx.userinfot.mobile), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_input, {
        modelValue: _ctx.informationForm.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.informationForm.code) = $event)),
        placeholder: "请输入短信验证码",
        class: "nameinput"
      }, null, 8, ["modelValue"]),
      (_ctx.isShow)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.countdown && _ctx.countdown(...args)))
          }, "获取短信验证码"))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.countShowText), 1))
    ]),
    _createElementVNode("button", {
      class: "routine submit",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next()))
    }, "下一步")
  ]))
}